import { createContext, useContext, useState, useEffect } from "react";
import { regUses, useTbl } from "../../axios_with_token";
import { getRootUrl, getBkendUrl } from "../../consts";

import product_1 from "../../assets/websitePictures/Endure Series/Premier-bedding.jpg";

import Anchor_series_1 from "../../assets/websitePictures/Anchor series - Percale/Anchor serie - Percale-Premier-bedding.jpg";

import Endure_Series_1 from "../../assets/websitePictures/Endure Series/Premier-bedding.jpg";

import Linen_Deluxe_series_1 from "../../assets/websitePictures/Linen-Deluxe series/Deluxe Hotel Sheets-350TC Sateen.jpg";
import Linen_Deluxe_series_2 from "../../assets/websitePictures/Linen-Deluxe series/Deluxe Micro stripe sheet.jpg";
import Linen_Deluxe_series_3 from "../../assets/websitePictures/Linen-Deluxe series/Deluxe series - Birdseye duvet cover.jpg";
import Linen_Deluxe_series_4 from "../../assets/websitePictures/Linen-Deluxe series/Deluxe series- Signature Sateen.jpg";
import Linen_Deluxe_series_5 from "../../assets/websitePictures/Linen-Deluxe series/Deluxe-signature-pillowcases.jpg";
import Linen_Deluxe_series_6 from "../../assets/websitePictures/Linen-Deluxe series/herringbone pattern-350HB-F.jpg";

import room_accessories_1 from "../../assets/websitePictures/room accessories/1.jpg";
import room_accessories_2 from "../../assets/websitePictures/room accessories/2.jpg";
import room_accessories_3 from "../../assets/websitePictures/room accessories/3.jpg";
import room_accessories_4 from "../../assets/websitePictures/room accessories/4.jpg";
import room_accessories_5 from "../../assets/websitePictures/room accessories/5.jpg";
import room_accessories_6 from "../../assets/websitePictures/room accessories/beige blanket-1.png";
import room_accessories_7 from "../../assets/websitePictures/room accessories/blanket gray.png";
import room_accessories_8 from "../../assets/websitePictures/room accessories/Down Pillows.jpg";
import room_accessories_9 from "../../assets/websitePictures/room accessories/Pool towel_harbour series.jpeg";
import room_accessories_10 from "../../assets/websitePictures/room accessories/Ptuck in duvet insert.jpg";
import room_accessories_11 from "../../assets/websitePictures/room accessories/red and white pool towel.png";
import room_accessories_12 from "../../assets/websitePictures/room accessories/Stock pool towel $16.png";
import room_accessories_13 from "../../assets/websitePictures/room accessories/velour bathrobe.jpg";

import Terry_1 from "../../assets/websitePictures/Terry/hotel Deluxe towel series.jpg";
import Terry_2 from "../../assets/websitePictures/Terry/Hotel Premier_Terry Picture.jpg";
import Terry_3 from "../../assets/websitePictures/Terry/make up face cloth.jpg";

import mattress_acc_1 from "../../assets/images/mattrress_acc1.jpg";
import mattress_acc_2 from "../../assets/images/mettress_acc2.avif";

import Amenity_1 from "../../assets/images/amenity2.webp";
import Amenity_2 from "../../assets/images/amenity.avif";

import { Description } from "@mui/icons-material";



const pdtsContext = createContext();
export function usePdtsContext(){
    return useContext(pdtsContext);
}

export function PdtsProvider({children}){
    function convertPdtCatsToPaths(paths, cats, parentIdx){
        paths = paths || {};
        cats.forEach((cat, catIdx)=>{
            const idx = (parentIdx==='root')?catIdx:[parentIdx, catIdx].join(',');
            paths[idx] = cat;
            // if(arrSubs)arrSubs.push(cat);
            // cat.arrSubs = [];
            if(cat.subs){
                convertPdtCatsToPaths(paths, cat.subs, idx);
                // if(arrSubs)arrSubs.concat(cat);
            }
        })

        return paths;
    }

    function genMapCatsToPaths(catsByPaths){
        const pdtCategoriesToPaths = {};
        Object.keys(catsByPaths).forEach(path=>{
            const cat = catsByPaths[path];
            pdtCategoriesToPaths[cat.caption] = path;
        });

        return pdtCategoriesToPaths;
    }

    const pdtCategories = [
        {
            caption: 'Linen',
            subs:[
                {
                    caption: 'Deluxe series',
                    images:[
                        {
                            url: Linen_Deluxe_series_1
                        },
                        {
                            url: Linen_Deluxe_series_2
                        },
                        {
                            url: Linen_Deluxe_series_3
                        },
                        {
                            url: Linen_Deluxe_series_4
                        },
                        {
                            url: Linen_Deluxe_series_5
                        },
                        {
                            url: Linen_Deluxe_series_6
                        }
                    ],
                    subs: [
                        {
                            caption: 'Birdseye Fusion Duvet Cover',
                            subs:[
                                {
                                    caption: 'Jacquard, T300',
                                    Description: '60% Cotton / 40% Polyester, pure white, combed cotton, satin finished Fushion Duvet Cover  1 DZ/Case'
                                },
                                {
                                    caption: 'Jacquard, T350 ',
                                    Description: '60% Cotton / 40% Polyester, pure white, combed cotton, satin finished Fushion Duvet Cover  1 DZ/Case'
                                }
                            ]
                        },
                        {
                            caption: 'Signature Micro stripe',
                            Description: 'Top Sheets and stripe pillowcases: T300, stylish tone on tone micro stripe - 60% Cotton / 40% Polyester, pure white, combed cotton, satin finished'
                        },
                        {
                            caption: 'Signature Sateen',
                            Description: 'Top Sheets and stripe pillowcases: T350, 80% Cotton / 20% Polyester, pure white, combed cotton'
                        }
                    ]
                },
                {
                    caption: 'Anchor series',
                    Description: 'Top Sheets and stripe pillowcases: T300, percale, 60% Cotton, 40% Polyester, pure white, combed cotton Fitted Sheets, 1 DZ/Case',
                    images:[
                        {
                            url: Anchor_series_1
                        }
                    ]
                },
                {
                    caption: 'Endure Series',
                    Description: 'Top Sheets and stripe pillowcases: T220, percale, 60% Cotton, 40% Polyester, pure white, combed cotton',
                    images:[
                        {
                            url: Endure_Series_1
                        }
                    ]
                }
            ]
        },
        {
            caption: 'Room Accessories',
            images:[
                {
                    url: room_accessories_1
                },
                {
                    url: room_accessories_2
                },
                {
                    url: room_accessories_3
                },
                {
                    url: room_accessories_4
                },
                {
                    url: room_accessories_5
                },
                {
                    url: room_accessories_6
                },
                {
                    url: room_accessories_7
                },
                {
                    url: room_accessories_8
                },
                {
                    url: room_accessories_9
                },
                {
                    url: room_accessories_10
                },
                {
                    url: room_accessories_11
                },
                {
                    url: room_accessories_12
                },
                {
                    url: room_accessories_13
                }
            ]
        },
        {
            caption: 'Terry',
            images:[
                {
                    url: Terry_1
                },
                {
                    url: Terry_2
                },
                {
                    url: Terry_3
                }
            ]

        },
        {
            caption: 'Bedding Essentials',
            Description: 'Duvet/Pillow/Blanket/Bedskirt'
        },
        {
            caption: 'Mattress Accessories',
            Description: 'PAD/Encasement',
            images: [
                {
                    url: mattress_acc_1
                },
                {
                    url: mattress_acc_2
                }
            ]
        },
        {
            caption: 'Amenities',
            Description: '',
            images: [
                {
                    url: Amenity_1
                },
                {
                    url: Amenity_2
                }
            ]
        }
    ];
    const pdtCategoriesByPaths = convertPdtCatsToPaths(false, pdtCategories, 'root');

    const mapCatsToPaths = genMapCatsToPaths(pdtCategoriesByPaths);

    const [category, setCategory] = useState([]);

    const {regUse, isLoading} = regUses();
    const {data:pdtsGot} = regUse(useTbl('pdts'));

    const allProducts = ((pdtsGot||{}).rcds || []).filter(pdt=>parseInt(pdt.shopShow) == 1);

    // [] depend mapCatsToPaths
    const getSubCategories = catCaption=>{
        function getSubCats(cat, subCats){
            subCats = subCats || [];
            subCats.push(cat.caption);
            if(cat.subs){
                cat.subs.forEach(sub=>getSubCats(sub, subCats));
            }
            return subCats;
        }
        const path = mapCatsToPaths[catCaption];
        const cat = catCaption?pdtCategoriesByPaths[path]:{
            caption: 'root',
            subs:pdtCategories
        };
        // pdtCategories

        return cat?getSubCats(cat):[];

    };

    const getSubCategoriesWithLevel = catCaption=>{
        function getSubCats(cat, level, subCats){
            subCats = subCats || [];
            subCats.push({
                level: level,
                caption: cat.caption,
                cap: ['-'.repeat(level), cat.caption].join('')
            });
            if(cat.subs){
                cat.subs.forEach(sub=>getSubCats(sub, level+1, subCats));
            }
            return subCats;
        }
        const path = mapCatsToPaths[catCaption];
        const cat = catCaption?pdtCategoriesByPaths[path]:{
            caption: 'root',
            subs:pdtCategories
        };
        // pdtCategories

        return cat?getSubCats(cat, 0):[];

    };
    // console.log(getSubCategories('Deluxe series'));

    // console.log(mapCatsToPaths);
    const getPdtsUnderCategory = catCaption=>{
        const arrCat = getSubCategories(catCaption);
        // console.log(arrCat);
        return (allProducts||[]).filter(pdt=>pdt.wwCategory&&arrCat.indexOf(pdt.wwCategory>=0));
    };
    // console.log(getPdtsUnderCategory());
    // console.log(getSubCategoriesWithLevel());

    const getPdtsUnderCategories = tgtCategories=>{
        let category = [];
        tgtCategories.forEach(cat=>{
            category = category.concat(getSubCategories(cat));
        })
        
        return allProducts.filter(pdt=>(category.indexOf(pdt.wwCategory)>=0));        
    }


    // const products = (category&&category.constructor===Array&&category.length>0)?(tgtCategories=>{
    //     let category = [];
    //     tgtCategories.forEach(cat=>{
    //         category = category.concat(getSubCategories(cat));
    //     })
        
    //     return allProducts.filter(pdt=>(category.indexOf(pdt.wwCategory)>=0));
    // })(category):allProducts;

    const products = (category&&category.constructor===Array&&category.length>0)?getPdtsUnderCategories(category):allProducts;
    
    const productsById = {}; //(pdtsGot||{}).rcdsById || {};

    const rootUrl = getRootUrl();
    const backendUrl =  getBkendUrl();

    products.forEach(pdt=>{
        productsById[pdt.__id] = pdt;
        if(pdt.images){
            if(pdt.images.constructor === String){
                try{
                    pdt.images = JSON.parse(pdt.images);
                }catch(err){
                    // console.log(pdt.images);
                    pdt.images = [];
                }
                pdt.images.forEach(imgDef=>{imgDef.url = `${backendUrl}/static/uploads/${imgDef.url.replace(/\\/g, '')}`});
            }
        }else{
            pdt.images = [];
        }


        if(pdt.images.length == 0){
            const catPath = mapCatsToPaths[pdt.wwCategory];
            const cat = pdtCategoriesByPaths[catPath] || {};
            // console.log(pdt.wwCategory, catPath, cat);
            const catImgs = (cat.images&&cat.images.length>0)?cat.images:[{url: product_1}];
            pdt.images[0] = catImgs[0];
        }
    });

    return <pdtsContext.Provider
        value={{
            products,
            productsById,
            pdtCategories,

            category,
            setCategory,

            getPdtsUnderCategories,
            getPdtsUnderCategory
        }}
    
    >
        {children}
    </pdtsContext.Provider>;
}